import { Layout } from "antd";
import Logofoot from "../assets/images/bg/footnectec.webp"

type Props = {
  collapsed: boolean;
};

const FooterLayout = ({ collapsed }: Props) => {
  const { Footer } = Layout;
  return (
    <Footer
      style={
        {textAlign:"center",
        backgroundColor:"#052240",
        padding:"5px",
      }
      }
    >
      <img style={{height:"40px" , float:"right"}} src={Logofoot} ></img>
    </Footer>
  );
};

export default FooterLayout;